import React, { useState, useEffect } from "react";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message, Select } from "antd";
import SideBar from "../../sidebar/sideBar.js";
import { getAllPartySearch } from "../../../api/endpoints/search.js";
import Header from "../../header/header.jsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
import { getAllItemsSearch } from "../../../api/endpoints/search";

const { Option } = Select;

const PartyBulkBill = () => {
  const { access_token } = useSelector(authSelector);

  const [loading, setLoading] = useState(false);

  const [state, setState] = useState({
    parties: [],
    partyId: "",
    customerName: "",
    quotationDate: "",
    refNo: "",
    items: [],

    itemName: "",
    quantity: "",
    saleRate: "",
    amount: "",

    NTN: "",
    siteAddress: "",
    siteName: "",
    phoneNo: "",
    Fax: "",
    email: "",

    term1: "",
    term2: "",
    term3: "",
    term4: "",
  });

  const onChangeText = (e) => {
    const { name, value } = e.target;

    setState({
      ...state,
      [name]: value,
    });
  };

  const getAllData = async () => {
    const result = await getSiteRefrence(access_token);
    const _parties = await getAllPartySearch(access_token);
    const _items = await getAllItemsSearch(access_token);

    setState((prev) => ({
      ...prev,
      parties: _parties,
      items: _items,
      NTN: result.data.NTNNO,
      phoneNo: result.data.phoneNo,
      Fax: result.data.Fax,
      email: result.data.email,
      siteAddress: result.data.siteAddress,
      siteName: result.data.siteName,
    }));
  };

  useEffect(() => {
    getAllData();
  }, []);

  const editHandler = async () => {
    if (!state.customerName) return message.error("Please Enter Customer Name");

    if (!state.quotationDate) return message.error("Please Select Date");

    if (!state.itemName) return message.error("Please Enter Item");

    if (!state.quantity) return message.error("Please Enter Quantity");

    if (!state.saleRate) return message.error("Please Enter Rate");

    const payload = [
      {
        itemName: state.itemName,
        quantity: Number(state.quantity),
        saleRate: Number(state.saleRate),
        amount: Number(state.quantity || 0) * Number(state.saleRate || 0),
      },
    ];

    generatePDF(payload);
  };

  const getBase64Image = (url) =>
    new Promise((resolve) => {
      const img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        resolve(canvas.toDataURL("image/jpeg"));
      };

      img.src = url;
    });

  const generatePDF = async (data) => {
    const doc = new jsPDF("p", "mm", "a4");

    const totalAmount = data.reduce(
      (a, b) => a + Number(b.quantity || 0) * Number(b.saleRate || 0),
      0
    );

    /* ================= LOGO ================= */

    const logo = await getBase64Image("/img/imexLogo.jpeg");
    doc.addImage(logo, "JPEG", 14, 10, 35, 22);

    const imexStamp = await getBase64Image("/img/imexStamp.jpeg");
    doc.addImage(imexStamp, "JPEG", 80, 150, 45, 32);

    /* ================= HEADER ================= */

    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);

    doc.text(`Date: ${formatDateLong(state.quotationDate)}`, 110, 18);
    doc.setFontSize(11);
    doc.text(`Ref: ${state.refNo}`, 110, 25);
    /* ================= CUSTOMER ================= */

    doc.setFontSize(12);

    const customerName = state.customerName || "";
    const wrappedCustomer = doc.splitTextToSize(customerName, 170);

    doc.text(wrappedCustomer, 14, 40);

    /* ================= TITLE ================= */

    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);

    doc.text(`Quotation for ${data[0]?.itemName || ""}`, 70, 60);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);

    /* ================= TABLE ================= */

    const tableRows = data.map((r, index) => {
      const amount = Number(r.quantity || 0) * Number(r.saleRate || 0);

      return [
        index + 1,
        "Liter",
        Number(r.quantity || 0).toLocaleString(undefined, {
          minimumFractionDigits: 2,
        }),
        r.itemName || "",
        Number(r.saleRate || 0).toLocaleString(undefined, {
          minimumFractionDigits: 2,
        }),
        amount.toLocaleString(undefined, {
          minimumFractionDigits: 2,
        }),
      ];
    });

    autoTable(doc, {
      startY: 65,
      head: [
        ["S.No", "Units", "Quantity", "Item", "Unit Price (PKR)", "Amount"],
      ],
      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 4,
        lineColor: [0, 0, 0],
        lineWidth: 0.3,
        textColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
      },
      columnStyles: {
        0: {
          halign: "center",
          cellWidth: 15,
        },
        1: {
          halign: "center",
          cellWidth: 25,
        },
        2: {
          halign: "right",
          cellWidth: 30,
        },
        3: {
          halign: "left",
          cellWidth: 55,
        },
        4: {
          halign: "right",
          cellWidth: 35,
        },
        5: {
          halign: "right",
          cellWidth: 30,
        },
      },
    });

    /* ================= TERMS ================= */

    let y = doc.lastAutoTable.finalY + 15;

    doc.setFont("helvetica", "bold");
    doc.text("Terms & Conditions:", 14, y);

    doc.setFont("helvetica", "normal");

    const terms = [state.term1, state.term2, state.term3, state.term4].filter(
      Boolean
    );

    terms.forEach((item, index) => {
      doc.text(`${index + 1}. ${item}`, 18, y + 8 + index * 7);
    });

    /* ================= TOTAL ================= */

    // y += 45;

    // doc.setFont("helvetica", "bold");

    // doc.text(
    //   `Total Amount : Rs. ${totalAmount.toLocaleString(
    //     undefined,
    //     {
    //       minimumFractionDigits: 2,
    //     }
    //   )}`,
    //   14,
    //   y
    // );

    /* ================= FOOTER ================= */

    y += 45;

    doc.setFont("helvetica", "normal");

    doc.text("Thanking & Assuring you our best services at all times,", 14, y);

    const leftLabelX = 14;
    const leftValueX = 40;

    y += 10;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);

    doc.text("Company:", leftLabelX, y);
    doc.text("NTN:", leftLabelX, y + 6);
    doc.text("Address:", leftLabelX, y + 12);
    doc.text("Phone:", leftLabelX, y + 18);
    doc.text("Fax:", 100, y + 18);
    doc.text("Email:", leftLabelX, y + 24);

    doc.setFont("helvetica", "normal");

    doc.text(state.siteName || "", leftValueX, y);
    doc.text(state.NTN || "", leftValueX, y + 6);
    doc.text(state.siteAddress || "", leftValueX, y + 12);
    doc.text(state.phoneNo || "", leftValueX, y + 18);
    doc.text(state.Fax || "", 110, y + 18);
    doc.text(state.email || "", leftValueX, y + 24);

    doc.setFont("helvetica", "bold");
    doc.text("For: Imex Associates", 14, y + 32);

    /* ================= OPEN PDF ================= */

    const pdfBlob = doc.output("blob");

    window.open(URL.createObjectURL(pdfBlob));
  };

  function formatDateLong(date) {
    if (!date) return "";

    const d = new Date(date);

    const options = {
      day: "numeric",
      month: "short",
      year: "numeric",
    };

    return d.toLocaleDateString("en-US", options);
  }

  return (
    <>
      <div className="flex bg-black main min-h-screen">
        <SideBar />
        <div className="h-full flex flex-col w-full">
          <Header />
          <div className="flex justify-center mt-6 mb-10">
            <div className="bg-[#111] border border-gray-700 rounded-lg w-full max-w-2xl">
              <div className="bg-blue-600 py-2 rounded-t-lg flex justify-center">
                <h1 className="text-white text-lg font-semibold">Quotation</h1>
              </div>
              <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* <div>
                  <label className="text-white text-xs mb-1 block">
                    Customer
                  </label>
                  <input
                    type="text"
                    name="customerName"
                    value={state.customerName}
                    onChange={onChangeText}
                    className="w-full bg-black text-white p-2 text-sm border border-gray-600 rounded"
                  />
                </div> */}
                <div>
                  <label className="text-white ml-2 mr-2" for="fname">
                    Account:
                  </label>
                  <Select
                    showSearch
                    style={{
                      cursor: "pointer !important",
                      background: "red !important",
                    }}
                    name="partyId"
                    placeholder="A/C No."
                    // className=" custom-select ant-select bg-black text-white inpTxt mt-5 p-1 h-9 w-64"
                    className="ant-select-item-option-active bg-black text-white  mt-5 h-9  w-64"
                    optionFilterProp="children"
                    value={state.customerName || "A/C No."}
                    onChange={(e) => {
                      console.log("e", e);

                      const _party = state.parties.find(
                        (el) => el.partyId === e
                      );
                      if (_party) {
                        setState({
                          ...state,
                          partyId: e,
                          customerName: _party.fullName,
                        });
                      } else {
                        setState({
                          ...state,
                          partyId: e,
                          customerName: "",
                        });
                      }
                    }}
                  >
                    <Option value={0}>None</Option>
                    {state.parties.map((el) => (
                      <Option
                        className="w-auto"
                        value={el.partyId}
                      >{`${el.partyId} - ${el.PartyName}`}</Option>
                    ))}
                  </Select>
                </div>

                {/* DATE */}
                <div>
                  <label className="text-white text-xs mb-1 block">Date</label>
                  <input
                    type="date"
                    name="quotationDate"
                    value={state.quotationDate}
                    onChange={onChangeText}
                    className="w-full bg-black text-white p-2 text-sm border border-gray-600 rounded"
                  />
                </div>

                {/* REF */}
                <div>
                  <label className="text-white text-xs mb-1 block">
                    Ref No
                  </label>
                  <input
                    type="text"
                    name="refNo"
                    value={state.refNo}
                    onChange={onChangeText}
                    className="w-full bg-black text-white p-2 text-sm border border-gray-600 rounded"
                  />
                </div>

                {/* ITEM */}
                {/* <div>
                  <label className="text-white text-xs mb-1 block">Item</label>
                  <input
                    type="text"
                    name="itemName"
                    value={state.itemName}
                    onChange={onChangeText}
                    className="w-full bg-black text-white p-2 text-sm border border-gray-600 rounded"
                  />
                </div> */}
                <Select
                  showSearch
                  placeholder="Select Product Name"
                  optionFilterProp="children"
                  className="mt-2 ml-3 h-8 p-1 w-60"
                  value={state.itemName || "Prodct Name"}
                  onChange={(e) => {
                    const { itemName: productName } = state.items.find(
                      (el) => el.itemCode === e
                    );
                    setState({
                      ...state,
                      itemCode: e,
                      itemName: productName,
                    });
                  }}
                >
                  {state.items.map((el) => (
                    <Option
                      value={el.itemCode}
                    >{`${el.itemCode} - ${el.itemName}`}</Option>
                  ))}
                </Select>

                {/* QTY */}
                <div>
                  <label className="text-white text-xs mb-1 block">Qty</label>
                  <input
                    type="number"
                    name="quantity"
                    value={state.quantity}
                    onChange={onChangeText}
                    className="w-full bg-black text-white p-2 text-sm border border-gray-600 rounded"
                  />
                </div>

                {/* RATE */}
                <div>
                  <label className="text-white text-xs mb-1 block">Rate</label>
                  <input
                    type="number"
                    name="saleRate"
                    value={state.saleRate}
                    onChange={onChangeText}
                    className="w-full bg-black text-white p-2 text-sm border border-gray-600 rounded"
                  />
                </div>

                {/* TERMS TITLE */}
                <div className="md:col-span-2 mt-2">
                  <h2 className="text-white text-sm font-semibold">
                    Terms & Conditions
                  </h2>
                </div>

                {/* TERM 1-4 (SMALLER) */}
                {[1, 2, 3, 4].map((n) => (
                  <div key={n}>
                    <label className="text-white text-xs mb-1 block">
                      Term {n}
                    </label>
                    <input
                      type="text"
                      name={`term${n}`}
                      value={state[`term${n}`]}
                      onChange={onChangeText}
                      className="w-full bg-black text-white p-2 text-sm border border-gray-600 rounded"
                    />
                  </div>
                ))}

                {/* BUTTON */}
                <div className="md:col-span-2 flex justify-center mt-2">
                  <button
                    className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded text-sm"
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Generate Quotation"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PartyBulkBill;
